import { useEffect, useRef } from 'react';
import { useCheckoutState } from '../../utils/checkoutState';
import { mountScript } from '../../utils/useScript';

const PAYPAL_IDENTIFIER = 'ABOUTYOU_9TPUV55AWFX9L_RT';

const PaypalPayment = () => {
  const { checkoutState } = useCheckoutState();
  const token = checkoutState.orderState.payment?.selected?.[0].configuration?.initializationData?.deviceIdent?.token;
  const previousToken = useRef();

  useEffect(() => {
    if (!token || token === previousToken.current) {
      return;
    }
    previousToken.current = token;
    const script = document.createElement('script');
    script.type = 'application/json';
    script.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
    script.innerHTML = JSON.stringify({ f: token, s: PAYPAL_IDENTIFIER });
    document.head.appendChild(script);

    mountScript('https://c.paypal.com/da/r/fb.js');
    // eslint-disable-next-line consistent-return
    return () => {
      document.head.removeChild(script);
    };
  }, [token, previousToken]);

  return null;
};

export default PaypalPayment;
